'use client';
import { jsx } from 'react/jsx-runtime';
import { FloatingLabelContextProvider } from '../../contexts/internal/floating-label/index.js';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(t, e) {
    if (null == t) return {};
    var o, r, n = _object_without_properties_loose(t, e);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);
        for(r = 0; r < i.length; r++)o = i[r], !(e.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(t, o) && (n[o] = t[o]);
    }
    return n;
}
function _object_without_properties_loose(t, e) {
    if (null == t) return {};
    var o, r, n = {}, i = Object.keys(t);
    for(r = 0; r < i.length; r++)o = i[r], e.indexOf(o) >= 0 || (n[o] = t[o]);
    return n;
}
let i = renderWithRef('DropdownWithFloatingLabel', null, (e, r)=>{
    let { fullWidth: i = false, children: l } = e, a = _object_without_properties(e, [
        "fullWidth",
        "children"
    ]), p = new Set([
        'swan-vanilla-ignore',
        'swan-dropdown-with-floating-label'
    ]);
    return i && p.add("swan-dropdown-with-floating-label-full-width"), jsx(FloatingLabelContextProvider, {
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: r,
            props: a,
            classNames: p,
            children: l
        })
    });
});
const DropdownWithFloatingLabel = deprecatedComponent({
    description: 'Use the generic component InputWithFloatingLabel instead',
    displayName: 'DropdownWithFloatingLabel',
    root: i
});

export { DropdownWithFloatingLabel };
